import React from 'react'
import ClubItem from './ClubItem'
import * as actions from '../store/actions'
import { connect } from 'react-redux'
import Swipable from './common/Swipable'

class GalleryCard extends React.Component {
  renderClubCard () {
    const {club, program, className, clubsCount, index, showPrevCard, showNextCard } = this.props
    return <ClubItem
      club={club}
      program={program}
      className={className}
      clubsCount={clubsCount}
      index={index}
      onSwipeLeft={showNextCard}
      onSwipeRight={showPrevCard}
    />
  }
  render () {
    const { className, showPrevCard, showNextCard } = this.props
    if(className === 'active-card') {
      return (
        <Swipable
          onSwipeLeft={showNextCard}
          onSwipeRight={showPrevCard}
        >
          {this.renderClubCard()}
        </Swipable>
      )
    }
    if(className === 'hidden') {
      return null
    }
    return this.renderClubCard()
  }
}

const classNamesMap = {
  '-2': 'far-right-card',
  '-1': 'prev-card',
  '0': 'active-card',
  '1': 'next-card',
  '2': 'far-left-card'
}

const stateToProps = (state, ownProps) => {
  const { selectedCardIndex, program } = state
  const { index } = ownProps
  // if the card to show is the selected one, the difference between indexes will be 0,
  // if it is 1 it means the card is the one next to the currently selected,
  // it it is -1 it means it is the one before the currently selected, and so on
  const distanceFromSelectedCard = index - selectedCardIndex
  const className = classNamesMap[distanceFromSelectedCard] || 'hidden'
  return {
    className,
    program
  }
}

export default connect(stateToProps, actions)(GalleryCard)



// WEBPACK FOOTER //
// ./src/components/GalleryCard.js